var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column form-submit btn-next"},[_c('b-button',{staticClass:"mr-2",attrs:{"disabled":!_vm.nextable,"loading":_vm.loading,"native-type":"submit"}},[_c('b-icon',{attrs:{"icon":'send',"type":"is-primary"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }